import { canHaveVotes, } from './top-level-comment-types';
import { getReactionsState } from '../reactions/comments-reaction-selectors';
import { getVoteState } from '../votes/comments-vote-selectors';
import flatMap from 'lodash/flatMap';
import flatten from 'lodash/flatten';
import { isDefined, unreachable } from '../../../../ts-utils';
import { getMarkedState } from '../mark/mark-selectors';
import { isMarkable } from '../mark/mark-types';
export const getCommentListIds = (topLevelCommentList, commentsById) => {
    const newCommentIds = flatten(topLevelCommentList.chunks
        .map((chunk) => {
        switch (chunk.type) {
            case 'NEW': {
                const commentState = commentsById[chunk.localOrCommentId];
                return 'commentId' in commentState ? [commentState.commentId] : [];
            }
            case 'LIVE': {
                return chunk.commentIds;
            }
            case 'FETCHED': {
                return [];
            }
            default:
                throw unreachable(chunk);
        }
    })
        .concat(topLevelCommentList.liveCommentsPurgatory));
    return flatMap(topLevelCommentList.chunks, (chunk) => chunk.type === 'FETCHED'
        ? filterNewComments(chunk.commentIds, newCommentIds)
        : chunk.type === 'LIVE'
            ? chunk.commentIds
            : chunk.localOrCommentId);
};
export const mapTopLevelCommentState = (topLevelCommentStateIN, memberState) => {
    const reactions = 'reactions' in topLevelCommentStateIN
        ? getReactionsState(topLevelCommentStateIN.reactions, memberState)
        : undefined;
    const marked = isMarkable(topLevelCommentStateIN)
        ? getMarkedState(topLevelCommentStateIN.comment, topLevelCommentStateIN.marked)
        : undefined;
    const votes = canHaveVotes(topLevelCommentStateIN)
        ? getVoteState(topLevelCommentStateIN.votes)
        : undefined;
    return {
        ...topLevelCommentStateIN,
        ...(reactions && { reactions }),
        ...(isDefined(marked) && { marked }),
        ...(votes && { votes }),
    };
};
// Just created comments might appear in latter comment fetches, so we filter them from chunks
const filterNewComments = (commentIds, newCommentIds) => commentIds.filter((id) => !newCommentIds.includes(id));
//# sourceMappingURL=top-level-comment-selectors.js.map